export default __webpack_public_path__ + "static/media/71.678e21c6.png";